import { render, staticRenderFns } from "./LibraryItem.vue?vue&type=template&id=4670ab5e&scoped=true&"
import script from "./LibraryItem.vue?vue&type=script&lang=js&"
export * from "./LibraryItem.vue?vue&type=script&lang=js&"
import style0 from "./LibraryItem.vue?vue&type=style&index=0&id=4670ab5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4670ab5e",
  null
  
)

export default component.exports